import { BuiltinMethod } from '@angular/compiler';
import { SiparisOnaySeviye } from './siparis-onay-seviye';

export class SiparisSiparisOnaySeviye {
  siparisId: number;
  siparisOnaySeviyeId: number;
  isOnay: boolean;
  siparisOnaySeviye: SiparisOnaySeviye;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
    if (obj.siparisOnaySeviye != null) {
      this.siparisOnaySeviye = new SiparisOnaySeviye(obj.siparisOnaySeviye);
    }
  }

  get isOnayText(): string {
    if (this.isOnay == null) {
      return 'Onay Bekliyor';
    }
    if (this.isOnay) {
      return 'Onaylandı';
    }
    if (!this.isOnay) {
      return 'Rededildi';
    }
    return '';
  }
}
